import { createContext, Dispatch, FC, ReactNode, SetStateAction, useContext, useState } from 'react';

type FacetExpansionState = Record<string, boolean>;

type FacetExpansionContextValue = [FacetExpansionState, Dispatch<SetStateAction<FacetExpansionState>>];

export const FacetExpansionContext = createContext<FacetExpansionContextValue | null>(null);

export const useFacetExpansionContext = () => {
    const context = useContext(FacetExpansionContext);

    if (!context) {
        throw new Error('useFacetExpansionContext must be used within FacetExpansionProvider');
    }

    return context;
};

type Props = {
    children: ReactNode;
    initialExpandedFacetIds?: string[];
};

export const FacetExpansionProvider: FC<Props> = ({ children, initialExpandedFacetIds = [] }) => {
    const expansionState = useState<FacetExpansionState>(() =>
        initialExpandedFacetIds.reduce<FacetExpansionState>(
            (acc, facetId) => ({
                ...acc,
                [facetId]: true,
            }),
            {},
        ),
    );

    return <FacetExpansionContext.Provider value={expansionState}>{children}</FacetExpansionContext.Provider>;
};
